import { Component, Input } from "@angular/core";
import { NgClass } from "@angular/common";

@Component({
    selector: "app-test-banner",
    imports: [NgClass],
    templateUrl: "./test-banner.component.html",
    styleUrl: "./test-banner.component.scss",
})
export class TestBannerComponent {
    @Input() position: "top-left" | "top-right" | "bottom-left" | "bottom-right" | "top" | "bottom" = "top-left";
}
